import { useFeatureFlagEnabled } from 'posthog-js/react';
import React from 'react';

import { Heading, Stack, Text } from '@eluve/components';
import { FeatureFlagKeysLookup } from '@eluve/posthog';

const MaintenancePage = () => {
  return (
    <Stack
      align="center"
      justify="center"
      className="min-h-screen bg-bg-secondary"
      gap={2}
    >
      <Stack
        align="center"
        className="mx-4 max-w-md rounded-lg bg-bg-primary p-8 shadow-lg"
        gap={2}
      >
        <span className="text-5xl" role="img" aria-label="Wrench">
          🔧
        </span>
        <Heading size="3xl" weight="semibold">
          Scheduled Maintenance
        </Heading>
        <Text color="supporting">
          We&apos;re upgrading our systems. Please check back shortly.
        </Text>
      </Stack>
    </Stack>
  );
};

export const MaintenanceGate: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const isMaintenanceMode =
    useFeatureFlagEnabled(FeatureFlagKeysLookup.MAINTENANCE_MODE) ?? false;

  if (isMaintenanceMode) {
    return <MaintenancePage />;
  }

  return children;
};
